<!--Popup Header -->
<div class="d-flex popup-head align-items-center">
  <div class="popup-title mr-auto" translate>
    {{ actionFlag === "Add" ? "lblAddCustomer" : "lblImportCustomer" }}
  </div>
  <div class="float-right">
    <a class="close mr-2" (click)="OnClose()" translate>
      <span aria-hidden="true">&times;</span>
    </a>
  </div>
</div>

<div class="container">
  <!-- Add Customer Form -->
  <form [formGroup]="addCustomerForm" (ngSubmit)="onSubmit()" *ngIf="actionFlag === 'Add'">
    <div class="card-accord scrollbar">
      <div class="card-content">
        <div class="card-body">
          <div class="row">
            <!-- Customer Name -->
            <div class="col-6">
              <label translate>
                lblName
                <strong class="mlt6 required"> * </strong>
              </label>
              <input type="text" formControlName="CustomerName" class="form-control" [ngClass]="{
                  'is-invalid':
                    cpf.CustomerName.dirty && cpf.CustomerName.errors
                }" />
              <div *ngIf="cpf.CustomerName.invalid && cpf.CustomerName.dirty" class="help-block text-danger">
                <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span translate>lblNameRequired</span>
              </div>
            </div>

            <!-- Mobile -->
            <div class="col-6 af-form-group">
              <label translate>lblMobile <strong class="mlt6 required"> * </strong></label>
              <div class="lbl-info">         
                <ngx-intl-tel-input [selectFirstCountry]= "false" formControlName="Mobile" [cssClass]="{ 'form-control': true,
                  'is-invalid':
                    (cpf.Mobile.touched || cpf.Mobile.dirty) &&
                    cpf.Mobile.errors
                }"
                [selectedCountryISO]="selectedCountryISO" [maxLength]="15" [phoneValidation]="false" 
                [separateDialCode]="true" [onlyCountries]="onlyCountries" [enablePlaceholder]="false" 
                (countryChange)="onCountryChange($event)"
                ></ngx-intl-tel-input>
              </div>
              <div *ngIf="
                  (cpf.Mobile.touched || cpf.Mobile.dirty) && cpf.Mobile.errors
                ">
                <div *ngIf="cpf.Mobile.errors.pattern" class="help-block mt-1 text-danger" translate>
                  lblEnterValidMobile
                </div>
              </div>
            </div>

            <!-- Email -->
            <div class="col-6 af-form-group">
              <label translate>lblEmail<strong class="mlt6 required"> * </strong></label>
              <div class="lbl-info">
                <input formControlName="Email" class="form-control" type="text" maxlength="64" [ngClass]="{
                    'is-invalid':
                      (cpf.Email.touched || cpf.Email.dirty) && cpf.Email.errors
                  }" />
              </div>
              <div *ngIf="
                  (cpf.Email.touched || cpf.Email.dirty) && cpf.Email.errors
                ">
                <div *ngIf="cpf.Email.errors.pattern" class="help-block mt-1 text-danger" translate>
                  lblEnterValidEmail
                </div>
              </div>
            </div>

            <!-- Dealer -->
            <div class="col-6">
              <label translate>lblDealer</label>
              <app-dealer-searchbox-dropdown [dealerList]="dealerList" [selectedDealer]="selectedDealer"
                ngDefaultControl (onSelectDealer)="onDealerSelected($event)">
              </app-dealer-searchbox-dropdown>
            </div>

            <!-- Address -->
            <div class="col-6">
              <label translate>lblAddress</label>
              <input type="text" formControlName="Address" class="form-control mb-2" />
            </div>

            <!-- Postal Code -->
            <div class="col-6">
              <label translate>lblPostalCode </label>
              <input type="text" formControlName="PostalCode" class="form-control mb-2" />
            </div>

            <!-- City -->
            <div class="col-6">
              <label translate>lblCity </label>
              <input type="text" formControlName="City" class="form-control mb-2" />
            </div>

            <!-- Reg Number -->
            <div class="col-6">
              <label translate>lblRegNumber </label>
              <input type="text" formControlName="LicensePlateNo" class="form-control mb-2" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Save / Close Button -->
    <div class="px-2 py-3">
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <button type="submit" class="btn btn-primary btn-lg mr-sm-2" [disabled]="addCustomerForm.status === 'INVALID'"
            aria-label="Center Align" translate>
            lblSave
          </button>
          <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate>lblCancel</a>
        </div>
      </div>
    </div>
  </form>

  <!-- Import Customer -->
  <div *ngIf="actionFlag === 'Import'">
    <div class="card scrollbar">
      <div class="card-content">
        <div class="card-body">
          <div class="d-flex justify-content-end">
            <label for="file-upload" class="btn btn-primary" translate>
              lblSelectExcelFile
            </label>
            <input type="file" id="file-upload" class="d-none" #inputFile accept=".xlsx"
              (change)="onFileChange($event)" />
            <div *ngIf="!validFormat" class="help-block text-danger">
              <em class="ft-alert-circle align-middle" aria-hidden="true"></em><span
                translate>lblInvalidExcelFormat</span>
            </div>
          </div>

          <div *ngIf="ImportedRecipients.length > 0">
            <div class="row">
              <div class="col-md-6">
                <h2 class="title16 text-primary" translate>
                  lblImportedRecipients
                </h2>
              </div>
            </div>
            <!--Recipients List-->
            <div class="row mt-2">
              <div class="col-md-12">
                <div class="table-responsive max-h415">
                  <table class="tablest1 fixed-header">
                    <thead>
                      <tr>
                        <th scope="col" translate>lblName</th>
                        <th scope="col" translate>lblEmail</th>
                        <th scope="col" translate>lblMobile</th>
                        <th scope="col" translate>lblAddress</th>
                        <th scope="col" translate>lblPostalCode</th>
                        <th scope="col" translate>lblCity</th>
                        <th scope="col" translate>lblDealer</th>
                        <th scope="col" translate>lblLicensePlate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of ImportedRecipients" [ngClass]="{ 'bg-danger': !item.valid }">
                        <td>{{ item.CustomerName }}</td>
                        <td>{{ item.Email }}</td>
                        <td>{{ item.Mobile }}</td>
                        <td>{{ item.Address }}</td>
                        <td>{{ item.PostalCode }}</td>
                        <td>{{ item.City }}</td>
                        <td>{{ item.DealerName }}</td>
                        <td>{{ item.LicensePlateNo }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="card-footer">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex justify-content-between">
                      <ngb-pagination [collectionSize]="pService.total$ | async" [(page)]="pService.page"
                        [pageSize]="pService.pageSize" [maxSize]="3">
                      </ngb-pagination>
                      <select class="custom-select mx-2" style="width: auto" name="pageSize"
                        [(ngModel)]="pService.pageSize">
                        <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>
                          {{ item.label }}
                        </option>
                      </select>
                    </div>
                    <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0">
                      <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{ pService.total$ | async
                      }}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-3 bg-light pp-footer-top-brdr">
      <div class="row">
        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
          <button type="submit" class="btn btn-primary btn-lg mr-sm-2" [disabled]="ImportedRecipients.length == 0"
            aria-label="Center Align" (click)="excelDataSave()" translate>
            <em class="far fa-save font16 align-top mr-2"></em> lblSave
          </button>
          <a (click)="OnClose()" class="btn btn-secondary btn-lg" translate><em
              class="far fa-times-circle font16 align-top mr-2"></em>
            lblCancel</a>
        </div>
      </div>
    </div>
  </div>
</div>